import { Box, Button, Grid, Paper, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CircleLoader from "react-spinners/CircleLoader";

import { UserContext } from "../../Context/UserContext";
import { GemRoutes } from "../../Routes";

interface Props {
  isTabbedSession: boolean;
  loading?: boolean;
  closeSession?: () => void;
  resumeSession?: () => void;
  startSession: () => void;
}

const validIvrUnavailableReason = process.env.REACT_APP_IVR_OUTBOUND_REASON || "Callback";

const CallWaiting: React.FC<Props> = ({
  isTabbedSession,
  loading = false,
  closeSession,
  resumeSession,
  startSession
}: Props) => {
  const navigate = useNavigate();
  const { ivrState, user } = useContext(UserContext);

  // if the user does not have an external ivr id, push them back to login
  useEffect(() => {
    if (user.externalIds.crm && !user.externalIds.ivr) navigate(GemRoutes.Login);
  }, [navigate, user.externalIds.crm, user.externalIds.ivr]);
  const invalidIvrState = ivrState.state !== "Unavailable" || ivrState.reason !== validIvrUnavailableReason;

  return (
    <Paper sx={{ padding: 2, minHeight: "12rem", width: "25rem" }}>
      <Grid container direction="column" justifyContent="center" alignItems="center" spacing={3}>
        {isTabbedSession ? (
          <>
            <Grid item>
              <Typography variant="body2">Contact Ended</Typography>
            </Grid>
            <Grid item>
              <Button onClick={() => resumeSession && resumeSession()}>Update Contact Session</Button>
            </Grid>
            <Grid item>
              <Button color="secondary" onClick={closeSession}>
                Close Session
              </Button>
            </Grid>
          </>
        ) : (
          <>
            <Grid item>
              <Box width="80px" height="80px">
                <CircleLoader size={80} color={"#F38B05"} />
              </Box>
            </Grid>
            <Grid item>
              <Typography variant="body2">{loading ? "Loading Contact..." : "Waiting for Contact"}</Typography>
            </Grid>
            {!loading && (
              <Grid item xs>
                <Tooltip
                  title={
                    invalidIvrState ? (
                      <>
                        <div>To start an outbound call you must be </div>
                        <div>{`Unavailable: ${validIvrUnavailableReason} in MAX.`}</div>
                      </>
                    ) : (
                      ""
                    )
                  }
                >
                  <span>
                    <Button onClick={startSession} disabled={invalidIvrState}>
                      Start Outbound Call
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            )}
            {!!resumeSession && (
              <Grid item>
                <Button onClick={() => resumeSession && resumeSession()}>Back to Previous Guest</Button>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Paper>
  );
};

export default CallWaiting;
